import { createRouter, createWebHistory } from 'vue-router';
import Board from '../components/Board.vue';
import RegisterBlog from '../components/RegisterBlog.vue';
import LoginBlog from '../components/LoginBlog.vue';
import ConfirmEmail from '../components/ConfirmEmail.vue';
import BCorp from '../components/BCorp.vue';
import ResetPassword from '../components/ResetPassword.vue'; // Importa il componente di reset della password
import Finder from '../components/Finder.vue';
import Users from '../components/UsersMng.vue';
import Videos from '../components/Videos.vue'; // Importa il componente
import Calendar from '../components/Calendar.vue'; // Importa il componente
import Customers from '../components/Customers.vue'; // Importa il componente
import SalonRegistration from '../components/SalonRegistration.vue'; // Importa il componente
import LinksHub from '../components/LinksHub.vue'; // Importa il componente LinksHub
import Dashboard from '../components/Dashboard.vue'; // Importa il componente del dashboard

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/board', component: Board, meta: { requiresAuth: true } },
  { path: '/register', component: RegisterBlog },
  { path: '/login', component: LoginBlog },
  { path: '/confirm/:token', component: ConfirmEmail },
  { path: '/bcorp', component: BCorp, meta: { requiresAuth: true } },
  { path: '/reset-password', component: ResetPassword, meta: { requiresAuth: true } }, // Aggiungi la rotta per il reset della password
  { path: '/finder', component: Finder, meta: { requiresAuth: true } }, 
  { path: '/users', component: Users, meta: { requiresAuth: true } },
  { path: '/videos', component: Videos },
  { path: '/calendar', component: Calendar },
  { path: '/customers', component: Customers },
  { path: '/salon', component: SalonRegistration },
  { path: '/hub', component: LinksHub },
  { path: '/dashboard', component: Dashboard, meta: { requiresAuth: true } }, // Aggiungi la rotta per il dashboard
];

const router = createRouter({
  history: createWebHistory('/EPeople/'),  
  routes,
});

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('token');
  console.log('token:', token)
  if(!token)
    token='';
  const isAuthenticated = !!token;
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next('/login');
  } else {
    next();
  }
});

export default router;

